<div class="content-container min-height m-t-20 user-report-page">
    <form (ngSubmit)="search()">
        <div class="ui-g">
            <div class="ui-g-12">
                <div class="main-topic-panel wsd-detail">
                    <h2>{{ 'USER_REPORTS.USERS_REPORT' | translate }}</h2>
                    <p-tabView>
                        <p-tabPanel [header]=" 'USER_REPORTS.HEADERS.USER_COUNTS' | translate ">
                            <wsd-user-count-tab [userTotalCount]="userTotalCount" [allCountries]="allCountries"
                                [allRegions]="allRegions" (triggerSpinner)="triggerSpinner($event)">
                            </wsd-user-count-tab>
                        </p-tabPanel>
                        <p-tabPanel [header]=" 'USER_REPORTS.HEADERS.ROLES' | translate ">
                            <wsd-role-count-tab [allCountries]="allCountries" [allRegions]="allRegions"
                                (triggerSpinner)="triggerSpinner($event)">
                            </wsd-role-count-tab>
                        </p-tabPanel>
                    </p-tabView>

                </div>
            </div>
        </div>
    </form>
</div>

<p-blockUI [blocked]="block">
    <div class="wrapper">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
</p-blockUI>
